// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInWeeks/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInWeeks = convertToFP(fn, 2);
export default differenceInWeeks;